var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fm-form-content",class:{
  'fm-form-inline': _vm.inline === undefined || _vm.inline === true || typeof _vm.inline === 'number',
  'fm-form-inline-2': typeof _vm.inline === 'number' && _vm.inline === 2,
  'fm-form-inline-3': typeof _vm.inline === 'number' && _vm.inline === 3,
  'fm-form-inline-4': typeof _vm.inline === 'number' && _vm.inline === 4
}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }